import algoliasearch from 'algoliasearch/lite'

const algoliaInit = algoliasearch(
  '2M84KN4PV0',
  '13b3e0d9f35c93cf4aaac8810dcbff08'
)

export default algoliaInit
